export function parseValidationErrors(validationErrors) {
  if (!validationErrors) return [];
  const result = {};
  validationErrors.forEach(error => {
    const camelCasePath = error.propertyName[0].toLowerCase() + error.propertyName.slice(1).replace(/\.[A-Z]/, m => m.toLowerCase());
    result[camelCasePath] = error.errorMessage;
  });
  return result;
}



// WEBPACK FOOTER //
// ./src/actions/backedValidationErrorsParser.js